// Зашиваем ID внутрь, для уменьшения колва работы разработчиков при интеграции
const YANDEX_METRICS_IDS = {
    COMMON: 159737,
    WHITELABEL: 87750877,
};

export { YANDEX_METRICS_IDS };
//# sourceMappingURL=consts.js.map
